import React from 'react';

function Modul() {
    return (
        <div className="flex absolute inset-0 z-50 items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white rounded-2xl p-8 max-w-2xl w-full max-h-[90vh] overflow-y-auto shadow-2xl">
                <h1 className="text-3xl font-bold text-gray-800 ">Oznam</h1>
                <p>Cas:</p>
                <p>Sprava</p>
            </div>
        </div>
    );
}

export default Modul;